import * as urlUtils from 'utils/Url';

export function getPathAccounts(qs={}) {
  return urlUtils.appendQueryString(`/accounts`, qs);
}

export function getPathAddAccount() {
  return `/accounts/add`;
}

export function getPathEditAccount(accountId) {
  return `/accounts/${accountId}/edit`;
}

export function getPathApiDetails() {
  return `/api-details`;
}

export function getPathMarketingPlatformConnections(qs={}) {
  return urlUtils.appendQueryString(`/marketing-platform-connections`, qs);
}

export function getPathAccountMembers(accountId, qs={}) {
  return urlUtils.appendQueryString(`/accounts/${accountId}/members`, qs);
}

// Webhooks
export function getPathWebhooks(qs={}) {
  return urlUtils.appendQueryString(`/webhooks`, qs);
}

export function getPathAddWebhook() {
  return `/webhooks/add`;
}

export function getPathEditWebhook(webhookId) {
  return `/webhooks/${webhookId}/edit`;
}

